import axios from 'axios';

const classattendance = {
    state: {  
		classattendances : []
	},	
	mutations: {		
		classattendances_success(state, payload){			
			state.classattendances = payload	
		}	
	},
	actions: {
        getclassattendance(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Classattendance/Getclassattendance', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {						
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},			
		getclassattendancebyid(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Classattendance/Getclassattendancebyid', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},						
		classattendanceregistration(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Classattendance/Registerclassattendance', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
        },        
	}
}

export default classattendance